import { prettifyPropName } from 'utils/recordDetailsUtils';

function DotLienParties({ parties }) {

	return parties.map((party, i) => {
		return (
			<div className="mb-3" key={i}>
				<div className="mb-1"><strong>{`${party.party_type || 'Party'} ${party.name || ''}`}</strong></div>
				{Object.keys(party).map((key) => {
					let value = party[key];
					return (
						<div key={key}>
							<span className="me-1">{prettifyPropName(key)}:</span>
							<span>{value || '-'}</span>
						</div>
					);
				})}
			</div>
		);
	});
}

export default DotLienParties;
